import { formatCorporatePageLabel, isCorporatePageFeature } from './corporatePageAccess';
import { formatPolicyMakerPageLabel } from './policyMakerPageAccess';

/** Human-readable labels for subscription plan `page:*` feature flags (admin + account UI). */
export const PAGE_FEATURE_DISPLAY_NAMES = {
  'page:overview': 'Overview',
  'page:supply-markets': 'Supply & Markets',
  'page:partners-risk': 'Partners & Risk',
  'page:policy-intelligence': 'Policy & Intelligence',
  'page:global-resource-sentinel': 'Global Resource Sentinel',
  'page:geoeconomic-ai': 'Strategic Intelligence',
  'page:event-tracker': 'Event Tracker',
  'page:intelligence-briefing': 'Intelligence Briefing',
  'page:global-competitiveness': 'Global Competitiveness',
  'page:methodology': 'Methodology',
  'page:predictive-alerts': 'Predictive Alerts',
  'page:crisis-simulator': 'Crisis Simulator',
  'page:company-risk-dashboard': 'Company Risk Intelligence',
  'page:ev-dashboard': 'EV Dashboard',
  'page:ev-crisis-simulator': 'EV Crisis Simulator',
};

export function formatPlanFeatureLabel(feature) {
  if (typeof feature !== 'string') return '';
  if (isCorporatePageFeature(feature)) return formatCorporatePageLabel(feature);
  if (feature.startsWith('policy_maker:')) return formatPolicyMakerPageLabel(feature);
  if (PAGE_FEATURE_DISPLAY_NAMES[feature]) return PAGE_FEATURE_DISPLAY_NAMES[feature];
  const [scope, rawName] = feature.split(':');
  const formattedScope = scope ? `${scope.charAt(0).toUpperCase()}${scope.slice(1).toLowerCase()}` : 'Feature';
  const formattedName = (rawName || '')
    .split('-')
    .filter(Boolean)
    .map((part) => `${part.charAt(0).toUpperCase()}${part.slice(1)}`)
    .join(' ');
  return `${formattedScope}: ${formattedName}`;
}
